import type MapSeries from 'echarts/lib/chart/map/MapSeries';
import { EChartsExtensionInstallRegisters } from 'echarts/lib/extension';
import GlobalModel from 'echarts/lib/model/Global';
import { VennDataItem, VennMapName } from './type';
import { REGION_CENTER_OFFSET } from './config';

function doLayout(model: MapSeries) {
  const { coordinateSystem } = model;
  const mapName = coordinateSystem.map as VennMapName;
  const data = model.getData();
  data.each(indice => {
    const rawData = data.getRawDataItem(indice) as VennDataItem;
    if (!rawData.name || !(rawData.__type && rawData.__type === 'region')) {
      return;
    }

    const region = coordinateSystem.getRegion(rawData.name);
    const center = region.calcCenter();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    if (!region._elOnlyForCalculate.contain(center[0], center[1])) {
      const offset = REGION_CENTER_OFFSET?.[mapName]?.[rawData.name];
      if (offset) {
        data
          .getItemGraphicEl(indice)
          .getTextContent()
          .attr({
            style: {
              x: offset[0],
              y: offset[1]
            }
          });
      }
    }
  });
}

function vennRegionLabelLayout(ecModel: GlobalModel) {
  // 过滤目标SeriesModel
  const targetModel = ecModel
    .getSeriesByType('map')
    .filter((series: MapSeries) => /^VENN__/.exec(series.get('map'))) as MapSeries[];

  targetModel.forEach(model => doLayout(model));
}

export function install(registers: EChartsExtensionInstallRegisters) {
  registers.registerUpdateLifecycle('series:layoutlabels', vennRegionLabelLayout);
}
